import React from 'react'
import 'antd/dist/antd.css'
import {
  SearchOutlined,
  EnvironmentOutlined,
  CheckOutlined,
  HomeOutlined,
} from '@ant-design/icons'
import { PAGE_COMPANY, PAGE_NAME } from '../../config'
import Top from '../../components/common/Top'
import Footer from '../../components/common/Footer'
import {
  Layout,
  Input,
  Button,
  Row,
  Col,
  Typography,
  Spin,
  message,
  Tooltip,
  Modal,
  Popover,
  Table,
  Form,
  List,
} from 'antd'
import {
  getWebsiteProject,
  getAdminRoomSelectionList,
  getAdminIntendedProjectCountList,
  getUserProjectSummaryInfo,
  getTransactionList,
  ListTransactionPublicityPaging,
  getApplyTransactionCheck,
  getTransactionPublicList,
} from '../../utils/api'
import Qualification from '../../components/model/qualificationPublic'
import QueryProgress from '../../components/model/queryProgress'
import actionWays from '../../redux/actions'
import { connect } from 'react-redux'
import moment from 'moment'
import { withRouter } from 'react-router-dom'
// import { Swiper, SwiperSlide } from "swiper/react";
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react'
import SwiperCore, { Autoplay, Pagination } from 'swiper'

import 'swiper/swiper-bundle.css'
import '../../inphone.scss'
const { Content } = Layout
const { Title } = Typography
SwiperCore.use([Autoplay, Pagination])
class Home extends React.Component {
  constructor(props) {
    super(props)
    this.handleResize = this.handleResize.bind(this);
    this.state = {
      swiperNum: 1,
      current: 'home',
      publicList: [],
      projectList: [],
      ctProjectListOut: [],
      ctProjectListIn: [],
      transactionPublicListOut: [],
      transactionPublicListIn: [],
      tableTotal: 0,
      ctProjectListTableTotal: 0,
      transactionPublicTableTotal: 0,
      lhProjectList: [],
      jjProjectList: [],
      showHome: false,
      showCertification: false,
      projectName: '',
      windowWidth: '',
      Views: false,
      secondsToGo: 5,
      okText: '5秒',
      ctVisible: false,
      lhVisible: false,
      jjVisible: false,
      certificationVisible: false,
      ctProjectName: '',
      ctRoomType: '',
      width: window.innerWidth
    }
    this.industryNews = null
    this.classertificationNews = null
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
    if (!sessionStorage.getItem('addInform')) {
      // this.ViewShow();
    }
    this.onloading()
    if (this.props.history.location) {
      if (this.props.history.location.query) {
        if (this.props.history.location.query.type == 'getQueryProgressList') {
          this.getQueryProgressList()
        }
        if (this.props.history.location.query.type == 'getQualificationList') {
          this.getQualificationList()
        }
      }
    }
  }
  componentWillUnmount() {
    this.setState(
      {
        showHome: false,
        showCertification: false,
      }
    )
    const { showHome, showCertification } = this.state
    if (showHome) {
      clearInterval(this.industryNews)
    }
    if (showCertification) {
      clearInterval(this.classertificationNews)
    }
  }
  onloading = async () => {
    let opts = {
      pageIndex: 0,
      pageSize: 100,
    }
    let opt = {
      projectName: '',
      district: '奉贤区',
      layout: '',
      minRent: '',
      maxRent: '',
      status: '',
      pageIndex: 0,
      pageSize: 6,
      choiceness: '1',
    }
    // 获取公示名单
    // let publicList = await ListTransactionPublicityPaging(opts)
    // if (publicList?.code === 0) {
    //   this.setState({
    //     publicList: publicList.data.pageContent,
    //   })
    // } else {
    //   message.error(publicList?.message)
    // }

    // 获取项目列表
    let projectList = await getWebsiteProject(opt)
    if (projectList?.code === 0) {
      for (let i in projectList.data.pageContent) {
        projectList.data.pageContent[i].mediaUrl =
          projectList.data.pageContent[i].mediaUrl.split(',')
      }
      this.setState({
        projectList: projectList.data.pageContent,
      })
    } else {
      message.error(projectList?.message)
    }

    this.getAdminRoomSelectionListFuc()
    this.getAdminIntendedProjectCountListFuc()
    this.getUserProjectSummaryInfoJJFuc()
    this.getTransactionPublicListFuc()
  }
  handleResize() {
    let centerDiv = document.querySelector(".centerContainer")
    let mainDiv = document.querySelector(".mainContainer")
    this.setState({ width: window.innerWidth });
    if (this.state.width >= 1200) {
      centerDiv.style.width = '1200px'
    }
    if (this.state.width < 1200) {
      mainDiv.style.paddingLeft = "20px"
      mainDiv.style.paddingRight = "20px"
    }
    // console.log(`窗口宽度：${this.state.width}`,'--------------屏幕宽度');
  }
  taskIndustryNews = () => {
    if (this.state.showHome) {
      if (
        this.refs.newDiv.scrollTop >=
        this.refs.newDivUI.offsetHeight - this.refs.newDiv.offsetHeight
      ) {
        this.refs.newDiv.scrollTop = 0
      } else {
        if (document.documentElement.clientWidth > 1903) {
          this.refs.newDiv.scrollTop += 2;
        } else {
          this.refs.newDiv.scrollTop += 1;
        }
        // this.refs.newDiv.scrollTop += 1
      }
    }
  }
  taskCertificationNews = () => {
    if (this.state.showCertification) {
      if (
        this.refs.newDiv2.scrollTop >=
        this.refs.newDivUI2.offsetHeight - this.refs.newDiv2.offsetHeight
      ) {
        this.refs.newDiv2.scrollTop = 0
      } else {
        if (document.documentElement.clientWidth > 1903) {
          this.refs.newDiv2.scrollTop += 2;
        } else {
          this.refs.newDiv2.scrollTop += 1;
        }
        // this.refs.newDiv2.scrollTop += 1
      }
    }
  }
  getAdminRoomSelectionListFuc = async (ctProjectName, ctRoomType, type) => {
    // 获取常态项目列表
    let ctProjectList = await getAdminRoomSelectionList({
      pageIndex: 0,
      pageSize: 10000,
      projectName: ctProjectName,
      roomType: ctRoomType,
    })
    if (ctProjectList?.code === 0) {
      if (type == 'all') {
        this.setState(
          {
            ctProjectListIn: ctProjectList.data.pageContent,
            ctProjectListTableTotal: ctProjectList.data.count,
          }
        )
      } else {
        this.setState(
          {
            ctProjectListOut: ctProjectList.data.pageContent,
            ctProjectListTableTotal: ctProjectList.data.count,
          },
          async () => {
            if (document.getElementById('homeId') !== null) {
              this.taskIndustryNews()
              this.industryNews = setInterval(this.taskIndustryNews, 300)
              this.setState({
                showHome: true,
              })
            }
          }
        )
      }
    } else {
      message.error(ctProjectList?.message)
    }
  }
  // 资格证公示
  getTransactionPublicListFuc = async (username, transactionNo, type) => {
    // clearInterval(this.classertificationNews)
    // 获取常态项目列表
    let transactionPublicList = await getTransactionPublicList({
      // pageIndex: 0,
      // pageSize: 10000,
      username: username,
      transactionNo: transactionNo,
    })
    if (transactionPublicList?.code === 0) {
      if (type == 'all') {
        this.setState(
          {
            transactionPublicListIn: transactionPublicList?.data,
            transactionPublicTableTotal: transactionPublicList?.data?.length,
          }
        )
      } else {
        this.setState(
          {
            transactionPublicListOut: transactionPublicList?.data,
            transactionPublicTableTotal: transactionPublicList?.data?.length,
          },
          async () => {
            if (document.getElementById('homeId') !== null && transactionPublicList?.data?.length > 0) {
              this.taskCertificationNews()
              this.classertificationNews = setInterval(this.taskCertificationNews, 300)
              this.setState({
                showCertification: true,
              })
            }
          }
        )
      }
    } else {
      message.error(transactionPublicList?.message)
    }
  }
  // 鼠标移入，停止滚动
  handleIndustryNewsEnter = () => {
    clearInterval(this.industryNews)
  }
  // 鼠标移出，开始滚动
  handleIndustryNewsLeave = () => {
    this.industryNews = setInterval(this.taskIndustryNews, 300)
  }
  // 鼠标移入，停止滚动
  handleCertificationNewsEnter = () => {
    clearInterval(this.classertificationNews)
  }
  // 鼠标移出，开始滚动
  handleCertificationNewsLeave = () => {
    this.classertificationNews = setInterval(this.taskCertificationNews, 300)
  }
  getAdminIntendedProjectCountListFuc = async () => {
    // 获轮候取项目列表
    let lhProjectList = await getAdminIntendedProjectCountList({
      pageIndex: 0,
      pageSize: 10000,
    })
    if (lhProjectList?.code === 0) {
      for (let i in lhProjectList.data.pageContent) {
        lhProjectList.data.pageContent[i].contentUrl =
          lhProjectList.data.pageContent[i].contentUrl.split(',')
      }
      this.setState({
        lhProjectList: lhProjectList.data.pageContent,
        tableTotal: lhProjectList.data.count,
      })
    } else {
      message.error(lhProjectList?.message)
    }
  }
  getUserProjectSummaryInfoJJFuc = async () => {
    // 获轮即将供应项目列表
    let jjProjectList = await getUserProjectSummaryInfo({
      pageIndex: 0,
      pageSize: 1000,
      district: '奉贤区',
      deadlineFlag: true,
      intendedProject: 1,
    })
    if (jjProjectList?.code === 0) {
      for (let i in jjProjectList.data.pageContent) {
        jjProjectList.data.pageContent[i].mediaUrl =
          jjProjectList.data.pageContent[i].mediaUrl.split(',')
      }
      this.setState({
        jjProjectList: jjProjectList.data.pageContent,
        tableTotal: jjProjectList.data.count,
      })
    } else {
      message.error(jjProjectList?.message)
    }
  }

  getProjectDetail = (projectName, projectNo) => {
    this.setState(
      {
        showHome: false,
        showCertification: false,
      },
      () => {
        this.props.history.push({
          pathname: '/belows',
          query: { projectName: projectName, projectNo: projectNo },
        })
      }
    )
  }
  getProject = (projectName) => {
    this.setState(
      {
        showHome: false,
        showCertification: false,
      },
      () => {
        this.props.history.push({
          pathname: '/project',
          query: { projectName: projectName },
        })
      }
    )
  }
  setValue = (n, e) => {
    const value = e.target ? e.target.value : e
    let obj = {}
    obj[n] = value
    this.setState({
      ...obj,
    })
  }
  // getProject = (projectName, projectNo) => {
  //     this.props.history.push({ pathname: '/belows', query: { projectName: projectName, projectNo: projectNo } })
  // }

  generateArray = (num) => {
    const arr = []
    const arr1 = []

    if (num <= 8) {
      for (let i = 1; i <= num; i++) {
        arr.push(i)
      }
    } else {
      for (let i = 1; i <= 5; i++) {
        arr.push(i)
      }
      for (let i = 6; i < num - 1; i++) {
        arr1.push(i)
      }

      arr.push('...')

      for (let i = num - 1; i <= num; i++) {
        arr.push(i)
      }
    }

    return [arr, arr1]
  }
  getApplyTransactionChecks = async (v) => {
    if (!v) {
      message.error('请先登录')
      return
    }
    let data = ''
    let list = await getApplyTransactionCheck({})
    if (list.code == 0) {
      data = '1'
      return data
    } else {
      data = '0'
      message.error(list.message)
      return data
    }
  }
  areatoraise = async () => {
    if (!this.props.userLoginInfo) {
      message.error('请先登录')
      return
    }
    let type = await this.getApplyTransactionChecks(this.props.userLoginInfo.id)
    if (type == '0') return
    this.props.history.push({
      pathname: '/areatoraise',
      query: { type: undefined },
    })
  }
  cityListsl = () => {
    this.props.history.push({ pathname: '/citylist' })
  }
  officialWebsite = (skipType) => {
    if (skipType) {
      this.setState(
        {
          showHome: false,
          showCertification: false,
        },
        () => {
          this.props.history.push({
            pathname: skipType,
          })
        }
      )
    }
  }
  render() {
    const {
      swiperNum,
      publicList,
      tableTotal,
      ctProjectListTableTotal,
      transactionPublicTableTotal,
      projectList,
      ctProjectListOut,
      ctProjectListIn,
      transactionPublicListOut,
      transactionPublicListIn,
      lhProjectList,
      jjProjectList,
      projectName,
      Views,
      secondsToGo,
      okText,
      ctVisible,
      lhVisible,
      jjVisible,
      certificationVisible,
    } = this.state
    const columns = [
      {
        title: '项目名称',
        dataIndex: 'projectName',
        minWidth: "28%"
      },
      {
        title: '房号',
        dataIndex: 'houseNo',
      },
      {
        title: '建筑面积',
        dataIndex: 'area',
      },
      {
        title: '户型',
        dataIndex: 'roomType',
      },
      {
        title: '月租金',
        dataIndex: 'monthlyRent',
      },
      {
        title: '状态',
        dataIndex: 'batchHouseStatus',
        render: (text, record) => {
          return (
            <span>
              {record.batchHouseStatus == 1 ? (
                '已选'
              ) : (
                <a style={{ color: '#40b563' }}>可选</a>
              )}
            </span>
          )
        },
      },
      {
        title: '操作',
        render: (text, record) => (
          <a
            onClick={() =>
              this.getProjectDetail(record.projectName, record.projectNo)
            }
          >
            查看详情
          </a>
        ),
      },
    ]
    const jjColumns = [
      {
        title: '项目名称',
        dataIndex: 'projectName',
      },
      {
        width: 150,
        title: '所在街道/镇',
        dataIndex: 'layout',
      },
      {
        title: '项目位置',
        dataIndex: 'location',
      },
      {
        width: 150,
        title: '项目户型',
        dataIndex: 'roomTypeInfos',
      },
      {
        width: 250,
        title: '项目简介',
        dataIndex: 'textContent',
      },
    ]
    const certification = [
      {
        title: '序号',
        dataIndex: 'index',
        render: (_, record, index) => index + 1
      },
      {
        title: '姓名',
        dataIndex: 'username',
        minWidth: "28%"
      },
      {
        title: '身份证号',
        dataIndex: 'idno',
      },
      {
        title: '资格证号',
        dataIndex: 'transactionNo',
      },
    ]
    const size = 368 / 150
    return (
      <Layout style={{ minHeight: '100%', minWidth: '100%' }} id="homeId">
        <Top
          getQualificationList={this.getQualificationList}
          getQueryProgressList={this.getQueryProgressList}
        />
        <Layout>
          <div className="homeTop">
            {/* <div className="col-lg-2"></div> */}
            {/* <div className="col-lg-8"> */}
            <div className='homeTop_content'>
              <div className="content">
                <Title level={1} style={{ marginBottom: '0' }}>
                  {/* 保租房，让生活更美好 */}
                </Title>
                <Title level={2}>
                  {/* {PAGE_COMPANY} */}
                  </Title>
                <div className="form">
                  <div className="input">
                    <Input
                      placeholder="查找您的意向小区"
                      onChange={this.setValue.bind(this, 'projectName')}
                    />
                    {/* <div className="position"><EnvironmentOutlined />地图找房</div> */}
                  </div>
                  <div style={{ position: 'relative' }}>
                    <Button
                      onClick={() => {
                        this.getProject(projectName)
                      }}
                    >
                      <SearchOutlined />
                      <span>
                        <b style={{ fontWeight: 'normal' }}>开始找房</b>{' '}
                      </span>
                    </Button>
                    {/* <Button className={'ditu'} style={{ position: 'absolute', right: '13rem', background: 'none', border: 'none', color: 'rgba(26, 56, 156, 1)', top: '0' }} onClick={() => { this.cityListsl() }}><EnvironmentOutlined />地图找房</Button> */}
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="col-lg-2"></div> */}
          </div>

          <Row className='mainContainer'>
            {/* <Col  className='leftContainer'></Col> */}
            <Col className='centerContainer' style={{ margin: '0 auto' }}>
              <Row className="qualification flex justSb">
                <div
                  className="ant-col"
                  onClick={() => {
                    // message.warning('敬请期待!')
                    // return
                    // window.location.href =
                    //   'https://www.wenjuan.design/s/UZBZJvCOOG'
                    window.open('https://www.wenjuan.com/s/YZZ3U33/#')
                  }}
                >
                  {/* <div className="qualification3"></div> */}
                  <img
                    className='pcImg'
                    style={{ width: '100%', height: '100%' }}
                    src={require('../../assets/images/home-qualification31.png').default}
                  ></img>
                  <img
                    className='mobileImg'
                    style={{ width: '100%', height: '100%' }}
                    src={require('../../assets/images/home-qualification31mobile.png').default}
                  ></img>
                </div>
                <div
                  className="ant-col"
                  onClick={() => {
                    this.cityListsl()
                  }}
                >
                  {/* <div className="qualification2"></div> */}
                  <img
                    className='pcImg'
                    style={{ width: '100%', height: '100%' }}
                    src={require('../../assets/images/home-qualification21.png').default}
                  ></img>
                  <img
                    className='mobileImg'
                    style={{ width: '100%', height: '100%' }}
                    src={require('../../assets/images/home-qualification21mobile.png').default}
                  ></img>
                </div>
                <div
                  className="ant-col"
                  onClick={() => {
                    this.setState({
                      jjVisible: true,
                    })
                  }}
                >
                  {/* <div className="qualification1"></div> */}
                  <img
                    className='pcImg'
                    style={{ width: '100%', height: '100%' }}
                    src={require('../../assets/images/home-qualification11.png').default}
                  ></img>
                  <img
                    className='mobileImg'
                    style={{ width: '100%', height: '100%' }}
                    src={require('../../assets/images/home-qualification11mobile.png').default}
                  ></img>
                </div>
              </Row>
              <Row className="publicList" style={{ marginTop: '48px' }}>
                <Col
                  className="mobileCTLHStyle"
                  xs={24}
                  sm={24}
                  lg={24}
                  xl={11}
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    marginBottom: '20px',
                  }}
                >
                  <div className="home-title">
                    <div className="left">
                      <span className="images images2"></span>
                      <div>常态化供应项目情况</div>
                    </div>
                    <div
                      className="right pcMarginRight"
                      onClick={() => {
                        this.setState({
                          ctVisible: true,
                        }),
                          this.getAdminRoomSelectionListFuc('', '', 'all')
                      }}
                    >
                      查看全部
                    </div>
                  </div>
                  <table className="projectListTable">
                    <thead>
                      <th>
                        <td className="projectName_td">项目名称</td>
                        <td className="roomNo_td">房号</td>
                        <td className="area_td">建筑面积</td>
                        <td className="houseType_td">户型</td>
                        <td className="amount_td">租金</td>
                        <td className="status_td">状态</td>
                      </th>
                    </thead>
                    <tbody
                      className="listBox"
                      ref="newDiv"
                      onMouseEnter={this.handleIndustryNewsEnter.bind(this)}
                      onMouseLeave={this.handleIndustryNewsLeave.bind(this)}
                    >
                      <div ref="newDivUI" className="flex flexC">
                        {ctProjectListOut.map((item, index) => {
                          return (
                            <tr className="listItem" key={index}>
                              <td className="projectName_td">
                                {item.projectName}
                              </td>
                              <td className="roomNo_td">{item.houseNo}</td>
                              <td className="area_td">{item.area}m²</td>
                              <td className="houseType_td">{item.roomType}</td>
                              <td className="amount_td">{item.monthlyRent}</td>
                              <td
                                className={
                                  item.batchHouseStatus == 1
                                    ? 'status_td'
                                    : 'status_td available'
                                }
                              >
                                {item.batchHouseStatus == 1 ? '已选' : '可选'}
                              </td>
                            </tr>
                          )
                        })}
                      </div>
                    </tbody>
                  </table>
                </Col>
                <Col xl={1} lg={0}></Col>
                <Col
                  className="mobileCTLHStyle"
                  xs={24}
                  sm={24}
                  lg={24}
                  xl={12}
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    marginBottom: '20px',
                  }}
                >
                  <div className="home-title">
                    <div className="left">
                      <span className="images images0"></span>
                      <div>轮候供应项目情况</div>
                    </div>
                    <div
                      className="right"
                      onClick={() => {
                        this.setState({
                          lhVisible: true,
                        })
                      }}
                    >
                      查看全部
                    </div>
                  </div>
                  <Swiper
                    // autoplay={{
                    //   delay: 2500,
                    //   disableOnInteraction: false,
                    // }}
                    pagination={{
                      clickable: true,
                      renderBullet: (index, className) => {
                        console.log(className)
                        const indexs = this.generateArray(lhProjectList.length)
                        return indexs[0].indexOf(index + 1) >= 0
                          ? '<span class="' +
                          className +
                          '">' +
                          (Number(index) + 1) +
                          '</span>'
                          : index + 1 == indexs[1][0]
                            ? '<span class="' +
                            className +
                            '">' +
                            '...' +
                            '</span>'
                            : '<span style="display: none;" class="' +
                            className +
                            '"></span>'
                      },
                    }}
                  >
                    {lhProjectList.map((item, index) => {
                      return (
                        <SwiperSlide key={index}>
                          <div className="waitingProjectDescInfo">
                            <div className="project-images">
                              {/* <div
                                style={{
                                  backgroundImage:
                                    'url(' + item.contentUrl[0] + ')',
                                  width: '100%',
                                  height: '100%',
                                  backgroundSize: 'cover',
                                  backgroundPosition: 'center',
                                  borderRadius: '5px',
                                  backgroundColor: '#F5F5F5',
                                  backgroundRepeat: 'no-repeat',
                                }}
                              ></div> */}
                              <img src={item.contentUrl[0]} alt="" style={{ width: '100%', maxWidth: '100%', height: '100%', maxHeight: '100%', objectFit: 'contain', borderRadius: '5px', backgroundColor: '#F5F5F5' }} />
                            </div>
                            <div className="projectInfoBox projectInfoBoxHeight right">
                              <div>
                                <div className="projectInfo">
                                  <div className="projectName flex justSb alignS">
                                    <span>{item.projectName}</span>
                                    <div
                                      className="flex alignS"
                                      style={{
                                        marginTop: '5px',
                                      }}
                                    >
                                      <Popover
                                        content={() => {
                                          return (
                                            <div
                                              style={{
                                                width: '200px',
                                              }}
                                            >
                                              {item.textContent}
                                            </div>
                                          )
                                        }}
                                        title={() => {
                                          return (
                                            <div className="flex alignC">
                                              <div
                                                style={{
                                                  width: '4px',
                                                  height: '18px',
                                                  background: ' #4767CF',
                                                }}
                                              ></div>
                                              <span
                                                style={{
                                                  marginLeft: '10px',
                                                }}
                                              >
                                                项目介绍
                                              </span>
                                            </div>
                                          )
                                        }}
                                      >
                                        <Button
                                          size="small"
                                          style={{
                                            background: '#023189',
                                            fontSize: '12px',
                                            color: '#FFFFFF',
                                            borderRadius: '50px',
                                            border: 'none',
                                          }}
                                        >
                                          项目介绍
                                        </Button>
                                      </Popover>
                                    </div>
                                  </div>
                                  <div className="regTime">
                                    轮候登记截止日期：{item.deadline}
                                  </div>
                                  <div className="address addressStyle">
                                    所属街道/镇：{item.layout}
                                  </div>
                                </div>
                              </div>
                              <div class="lhcontent">
                                <div class="content-box">
                                  <div className="content-label">总人数：</div>
                                  <div className="content-value">
                                    {item.totalTypeInfos}人
                                  </div>
                                </div>
                                <div class="content-box">
                                  <div className="content-label">一室户：</div>
                                  <div className="content-value">
                                    {item.oneHouseType
                                      ? item.oneHouseType + '人'
                                      : '无房源'}
                                  </div>
                                </div>
                                <div class="content-box">
                                  <div className="content-label">二室户：</div>
                                  <div className="content-value">
                                    {item.twoHouseType
                                      ? item.twoHouseType + '人'
                                      : '无房源'}
                                  </div>
                                </div>
                                <div class="content-box">
                                  <div className="content-label">三室户：</div>
                                  <div className="content-value">
                                    {item.threeContent
                                      ? item.threeContent + '人'
                                      : '无房源'}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </SwiperSlide>
                      )
                    })}
                  </Swiper>
                  {/* <div className="waitingProjectDesc">
                    <div
                      style={{
                        width: "200px",
                        height: "160px",
                        backgroundSize: "100%",
                        backgroundRepeat: "no-repeat",
                        background: "#efefef",
                      }}
                    >
                      图片占位
                    </div>
                    <div className="projectInfo">
                      <div className="projectName">金海壹品苑</div>
                      <div className="regTime">
                        轮候登记截止日期：2023-08-24
                      </div>
                      <div className="address">所属街道/镇：南桥镇</div>
                    </div>
                  </div> */}
                </Col>
              </Row>
              <Row className='publicList' style={{ marginTop: '48px' }}>
                <Col
                  className="mobileCTLHStyle"
                  xs={24}
                  sm={24}
                  lg={24}
                  xl={11}
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    marginBottom: '20px',
                  }}
                >
                  <div className="home-title">
                    <div className="left">
                      <span className="images images2"></span>
                      <div>资格证公示</div>
                    </div>
                    <div
                      className="right pcMarginRight"
                      onClick={() => {
                        this.setState({
                          certificationVisible: true,
                        }),
                          this.getTransactionPublicListFuc('', '', 'all')
                      }}
                    >
                      查看全部
                    </div>
                  </div>
                  <table className="projectListTable">
                    <thead>
                      <th>
                        <td className="username_td">姓名</td>
                        <td className="idno_td">身份证号</td>
                        <td className="transactionNo_td">资格证号</td>
                      </th>
                    </thead>
                    <tbody
                      className="listBox"
                      ref="newDiv2"
                      onMouseEnter={this.handleCertificationNewsEnter.bind(this)}
                      onMouseLeave={this.handleCertificationNewsLeave.bind(this)}
                    >
                      {transactionPublicListOut ? <div ref="newDivUI2" className="flex flexC">
                        {transactionPublicListOut.map((item, index) => {
                          return (
                            <tr className="listItem" key={index}>
                              <td className="username_td">{item.username}</td>
                              <td className="idno_td">{item.idno}</td>
                              <td className="transactionNo_td">{item.transactionNo}</td>
                            </tr>
                          )
                        })}
                      </div> : ''}
                    </tbody>
                  </table>
                </Col>
                <Col xl={1} lg={0}></Col>
                <Col className="mobileCTLHStyle"
                  xs={24}
                  sm={24}
                  lg={24}
                  xl={12}
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    marginBottom: '20px',
                  }}>
                  <div className="home-title">
                    <div className="left">
                      <span className="images images2"></span>
                      <div>申请下载</div>
                    </div>
                  </div>
                  <div className='requestToDownload'>
                    <div
                      className="ant-col"
                      onClick={() => {
                        this.officialWebsite('/requestConditions')
                      }}
                    >
                      <img
                        className='pcImg'
                        src={require('../../assets/images/requestConditions.png').default}
                      ></img>
                      <span>申请条件</span>
                    </div>
                    <div
                      className="ant-col"
                      onClick={() => {
                        this.officialWebsite('/requestFlow')
                      }}
                    >
                      <img
                        className='pcImg'
                        src={require('../../assets/images/requestFlow.png').default}
                      ></img>
                      <span>申请流程</span>
                    </div>
                    <div
                      className="ant-col"
                      onClick={() => {
                        this.officialWebsite('/dataDownload')
                      }}
                    >
                      <img
                        className='pcImg'
                        src={require('../../assets/images/requestDownload.png').default}
                      ></img>
                      <span>资料下载</span>
                    </div>
                    <div
                      className="ant-col"
                      onClick={() => {
                        this.officialWebsite('/requestProblem')
                      }}
                    >
                      <img
                        className='pcImg'
                        src={require('../../assets/images/requestProblem.png').default}
                      ></img>
                      <span>常见问题</span>
                    </div>
                  </div>
                </Col>
              </Row>

              <Row className="publicList" style={{ marginTop: '10px' }}>
                <Col span={24}>
                  <div className="home-title">
                    <div className="left">
                      <span className="images images1"></span>
                      <div>推荐项目</div>
                      <span>为您推荐精心挑选的小区</span>
                    </div>
                    <div
                      className="right"
                      onClick={() => {
                        this.getProject()
                      }}
                    >
                      查看全部
                    </div>
                  </div>
                </Col>
                <Col span={24}>
                  <ul className="home-project">
                    {projectList && projectList.length > 0 ? (
                      projectList.map((item, index) => {
                        return (
                          <li
                            className={(index + 1) % 2 == 0 ? 'justE' : 'justS'}
                            key={index}
                            onClick={() => {
                              this.getProjectDetail(
                                item.projectName,
                                item.projectNo
                              )
                            }}
                          >
                            <div className="project-images">
                              <div
                                style={{
                                  // backgroundImage:
                                  //   'url(' + item.mediaUrl[0] + ')',
                                  width: '100%',
                                  height: '100%',
                                  // backgroundSize: 'cover',
                                  // backgroundPosition: 'center',
                                  // borderRadius: '5px',
                                  // backgroundColor: '#F5F5F5',
                                  // backgroundRepeat: 'no-repeat',
                                  position: 'relative',
                                }}
                              >
                                <img src={item.mediaUrl[0]} alt="" style={{ width: '100%', maxWidth: '100%', height: '100%', maxHeight: '100%', objectFit: 'contain', borderRadius: '5px', backgroundColor: '#F5F5F5' }} />
                                {item.vrUrl && item.vrUrl.length > 0 ? (
                                  <div
                                    className="homeVr"
                                    onClick={(e) => {
                                      window.open(item.vrUrl)
                                      e.stopPropagation()
                                    }}
                                  >
                                    VR
                                  </div>
                                ) : null}
                              </div>
                            </div>
                            <div className="right">
                              <div className="top">
                                <span
                                  style={{ fontSize: '28px', color: '#262626' }}
                                >
                                  {item.projectName}
                                </span>

                                <div
                                  style={{
                                    fontSize: '28px',
                                  }}
                                >
                                  {item.minRent}-{item.maxRent}
                                  <span
                                    style={{
                                      fontSize: '16px',
                                    }}
                                  >
                                    {' '}
                                    元/月
                                  </span>
                                </div>
                              </div>
                              <div className="bottom">
                                {/* {item.openQueue === '1' && ( */}
                                <div className="marginShiHu">
                                  <CheckOutlined /> 现可租
                                  <Tooltip
                                    placement="topLeft"
                                    title={item.roomTypeCount}
                                  >
                                    <span style={{ color: '#3651a9' }}>
                                      {item.kezuCount}
                                    </span>
                                  </Tooltip>
                                  套
                                </div>
                                {/* )} */}
                                <div className="shihu marginShiHu">
                                  <HomeOutlined />{' '}
                                  {item.roomType && item.roomType.length > 0 ? (
                                    item.roomType
                                      .split(',')
                                      .map((item1, index1) => {
                                        return (
                                          <span key={index1}>
                                            {item1}室户
                                            {index1 + 1 ==
                                              item.roomType.split(',').length
                                              ? ''
                                              : '/'}
                                          </span>
                                        )
                                      })
                                  ) : (
                                    <span className="noData">暂无数据</span>
                                  )}
                                </div>
                                <div className="shihu marginShiHu">
                                  <EnvironmentOutlined /> {item.location}
                                </div>
                              </div>
                            </div>
                          </li>
                        )
                      })
                    ) : projectList.length == 0 ? (
                      <span className="noData">暂无数据</span>
                    ) : (
                      <Spin
                        style={{
                          width: '100%',
                          height: '600px',
                          lineHeight: '600px',
                        }}
                      />
                    )}
                  </ul>
                </Col>
              </Row>
              <Qualification ref="qualification" />
              <QueryProgress ref="queryProgress" />
            </Col>
            {/* <Col className='rightContainer'></Col> */}
          </Row>
          <Modal
            width={999}
            title={
              <h4
                style={{
                  fontFamily: '宋体',
                  marginBottom: '0',
                  fontWeight: 'bold',
                }}
              >
                通知栏
              </h4>
            }
            visible={Views}
            destroyOnClose={true}
            closable={false}
            okButtonProps={{ disabled: secondsToGo == 0 ? false : true }}
            okText={okText}
            cancelText={false}
            maskClosable={false}
            onOk={() => this.handleOkAndhandleCancel()}
          >
            <p
              style={{
                fontSize: '16px',
                fontFamily: '宋体',
                fontWeight: 'bold',
              }}
            >
              尊敬的用户:
              <br />
            </p>
            <p
              style={{
                fontSize: '16px',
                fontFamily: '宋体',
                fontWeight: 'bold',
              }}
            >
              &nbsp;&nbsp;为了给您提供更好的安全服务，我们已将系统升级，您登录系统时，如原密码强度不够（密码长度至少8位，至少1个大写字母，1个小写字母，1个数字和1个特殊字符），请选择忘记密码自行修改。
            </p>
            <p
              style={{
                fontSize: '16px',
                fontFamily: '宋体',
                fontWeight: 'bold',
              }}
            >
              &nbsp;&nbsp;给您带来的不便，敬请谅解。感谢您一直以来的支持！
            </p>
            <p
              style={{
                fontSize: '16px',
                fontFamily: '宋体',
                fontWeight: 'bold',
                textAlign: 'right',
              }}
            >
              {PAGE_NAME} <br /> {moment().format('LL')}
            </p>
          </Modal>
          <Modal
            width={1200}
            style={{
              top: 40,
            }}
            visible={ctVisible}
            destroyOnClose={true}
            closable={false}
            title={[
              <div>
                <div style={{ fontSize: '16px', color: '#262626' }}>
                  常态供应项目情况
                </div>
                <div style={{ fontSize: '13px', color: '#909090' }}>
                  房源情况每半月更新一次
                </div>
              </div>,
            ]}
            footer={null}
            onCancel={() =>
              this.setState({
                ctVisible: false,
              })
            }
          >
            <Form
              name="customized_form_controls"
              layout="inline"
              onFinish={(values) => {
                this.getAdminRoomSelectionListFuc(
                  values.projectName,
                  values.roomType,
                  'all'
                )
              }}
              style={{
                marginBottom: '24px',
              }}
            >
              <Row justify="space-around" align="middle">
                <Col span={8}>
                  <Form.Item name="projectName">
                    <Input placeholder="请输入项目名称" />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item name="roomType">
                    <Input placeholder="请输入户型" />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item>
                    <Button
                      style={{
                        background: '#023189',
                        fontSize: '12px',
                        color: '#FFFFFF',
                        border: 'none',
                      }}
                      htmlType="submit"
                    >
                      查询
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
            <Table
              columns={columns}
              dataSource={ctProjectListIn}
              scroll={{
                x: 'max-content',
                y: '400px',
              }}
              pagination={{
                total: ctProjectListTableTotal,
              }}
            />
          </Modal>
          <Modal
            width={1200}
            style={{
              top: 40,
            }}
            visible={certificationVisible}
            destroyOnClose={true}
            closable={false}
            title={[
              <div>
                <div style={{ fontSize: '16px', color: '#262626' }}>
                  资格证公示
                </div>
              </div>,
            ]}
            footer={null}
            onCancel={() =>
              this.setState({
                certificationVisible: false,
              })
            }
          >
            <Form
              name="customized_form_controls"
              layout="inline"
              onFinish={(values) => {
                this.getTransactionPublicListFuc(
                  values.username,
                  values.transactionNo,
                  'all'
                )
              }}
              style={{
                marginBottom: '24px',
              }}
            >
              <Row justify="space-around" align="middle">
                <Col span={8}>
                  <Form.Item name="username">
                    <Input placeholder="请输入姓名" />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item name="transactionNo">
                    <Input placeholder="请输入资格证号" />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item>
                    <Button
                      style={{
                        background: '#023189',
                        fontSize: '12px',
                        color: '#FFFFFF',
                        border: 'none',
                      }}
                      htmlType="submit"
                    >
                      查询
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
            <Table
              columns={certification}
              dataSource={transactionPublicListIn}
              scroll={{
                x: 'max-content',
                y: '400px',
              }}
              pagination={{
                total: transactionPublicTableTotal,
              }}
            />
          </Modal>
          <Modal
            width={888}
            style={{
              top: 40,
            }}
            visible={lhVisible}
            destroyOnClose={true}
            closable={false}
            title={[
              <div>
                <div style={{ fontSize: '16px', color: '#262626' }}>
                  轮候供应项目情况
                </div>
              </div>,
            ]}
            footer={null}
            onCancel={() =>
              this.setState({
                lhVisible: false,
              })
            }
          >
            <List
              className="lhgyList"
              grid={{
                column: 1,
                gutter: 1,
              }}
              itemLayout="vertical"
              pagination={{
                onChange: (page) => {
                  console.log(page)
                },
              }}
              dataSource={lhProjectList}
              renderItem={(item) => (
                <div className="waitingProjectDescInfo waitingProjectDescInfoPM">
                  <div className="project-images">
                    {/* <div
                      style={{
                        backgroundImage: 'url(' + item.contentUrl[0] + ')',
                        width: '100%',
                        height: '100%',
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        borderRadius: '5px',
                        backgroundColor: '#F5F5F5',
                        backgroundRepeat: 'no-repeat',
                      }}
                    ></div> */}
                    <img src={item.contentUrl[0]} alt="" style={{ width: '100%', maxWidth: '100%', height: '100%', maxHeight: '100%', objectFit: 'contain', borderRadius: '5px', backgroundColor: '#F5F5F5' }} />
                  </div>
                  <div className="projectInfoBox flex flexC justSb">
                    <div className="projectInfoBoxTop">
                      <div className="projectInfo">
                        <div className="projectName flex justSb">
                          {item.projectName}
                          <div className="pcProjectInfojieshao">
                            <Popover
                              content={() => {
                                return (
                                  <div
                                    style={{
                                      width: '200px',
                                    }}
                                  >
                                    {item.textContent}
                                  </div>
                                )
                              }}
                              title={() => {
                                return (
                                  <div className="flex alignC">
                                    <div
                                      style={{
                                        width: '4px',
                                        height: '18px',
                                        background: ' #4767CF',
                                      }}
                                    ></div>
                                    <span
                                      style={{
                                        marginLeft: '10px',
                                      }}
                                    >
                                      项目介绍
                                    </span>
                                  </div>
                                )
                              }}
                            >
                              <Button
                                size="small"
                                style={{
                                  background: '#023189',
                                  fontSize: '12px',
                                  color: '#FFFFFF',
                                  borderRadius: '50px',
                                  border: 'none',
                                }}
                              >
                                项目介绍
                              </Button>
                            </Popover>
                          </div>
                        </div>
                        <div className="flex alignC mobileRegAddressTime">
                          <div className="regTime">
                            轮候登记截止日期：{item.deadline}
                          </div>
                          <div className="addressStyle spaceMargin">
                            所属街道/镇：{item.layout}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="lhcontentInformation">
                      <div class="content-box">
                        <div className="content-label">总人数：</div>
                        <div className="content-value">
                          {item.totalTypeInfos}人
                        </div>
                      </div>
                      <div class="content-box spaceMargin">
                        <div className="content-label">一室户：</div>
                        <div className="content-value">
                          {item.oneHouseType
                            ? item.oneHouseType + '人'
                            : '无房源'}
                        </div>
                      </div>
                      <div class="content-box spaceMargin">
                        <div className="content-label">二室户：</div>
                        <div className="content-value">
                          {item.twoHouseType
                            ? item.twoHouseType + '人'
                            : '无房源'}
                        </div>
                      </div>
                      <div class="content-box spaceMargin">
                        <div className="content-label">三室户：</div>
                        <div className="content-value">
                          {item.threeContent
                            ? item.threeContent + '人'
                            : '无房源'}
                        </div>
                      </div>
                    </div>
                    <div className="projectInfojieshao mobileProjectInfojieshao">
                      <Popover
                        content={() => {
                          return (
                            <div
                              style={{
                                width: '200px',
                              }}
                            >
                              {item.textContent}
                            </div>
                          )
                        }}
                        title={() => {
                          return (
                            <div className="flex alignC">
                              <div
                                style={{
                                  width: '4px',
                                  height: '18px',
                                  background: ' #4767CF',
                                }}
                              ></div>
                              <span
                                style={{
                                  marginLeft: '10px',
                                }}
                              >
                                项目介绍
                              </span>
                            </div>
                          )
                        }}
                      >
                        <Button
                          size="small"
                          style={{
                            background: '#023189',
                            fontSize: '12px',
                            color: '#FFFFFF',
                            borderRadius: '50px',
                            border: 'none',
                          }}
                        >
                          项目介绍
                        </Button>
                      </Popover>
                    </div>
                  </div>
                </div>
              )}
            />
          </Modal>
          <Modal
            width={1200}
            style={{
              top: 40,
            }}
            visible={jjVisible}
            destroyOnClose={true}
            closable={false}
            title={[
              <div>
                <div style={{ fontSize: '16px', color: '#262626' }}>
                  即将供应房源
                </div>
              </div>,
            ]}
            footer={null}
            onCancel={() =>
              this.setState({
                jjVisible: false,
              })
            }
          >
            <Table
              columns={jjColumns}
              scroll={{
                x: 'max-content',
                y: '550px',
              }}
              pagination={false}
              dataSource={jjProjectList}
            />
          </Modal>
        </Layout>
        <Footer />
      </Layout>
    )
  }
  ViewShow = () => {
    let { secondsToGo } = this.state
    this.timer = setInterval(() => {
      secondsToGo -= 1
      this.setState({
        secondsToGo: secondsToGo,
        okText: secondsToGo + '秒',
      })
      if (secondsToGo == 0) {
        clearInterval(this.timer)
        this.setState({
          okText: '确定',
        })
      }
    }, 1000)
    this.setState(
      {
        Views: true,
      },
      () => {
        setTimeout(() => {
          if (secondsToGo == 0) clearInterval(this.timer)
        }, 1000)
      }
    )
  }
  handleOkAndhandleCancel = () => {
    this.setState(
      {
        Views: false,
      },
      () => {
        clearInterval(this.timer)
        sessionStorage.setItem('addInform', '1')
      }
    )
  }
  handleOkAndhandleCancels = () => {
    this.setState(
      {
        Views: false,
      },
      () => {
        clearInterval(this.timer)
      }
    )
  }
  tableBody = (item, index) => {
    return (
      <li key={index}>
        <span className="username">{item.username}</span>
        <span className="telephone">{item.transactionNo}</span>
      </li>
    )
  }
  getQualificationList = () => {
    this.refs.qualification.showQualification()
  }
  getQueryProgressList = () => {
    this.refs.queryProgress.showQueryProgress()
  }
}
const mapStateToProps = (state) => {
  return {
    userLoginInfo: state.userLoginInfo,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    saveLoginInfo: (...args) => dispatch(actionWays.saveLoginInfo(...args)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Home))
